"use client";

import PageHead from "./PageHead";
import PageHero from "./PageHero";
import Footer from "./Footer";
import Header1 from "./Header1";

export default function Layout({
    children,
    pageTitle,
    pageId,
    activePage,
    headTitle,
}: any) {
    return (
        <>
            <PageHead headTitle={headTitle} />
            <Header1 />

            <div id="page" className="page bg-white">
                {pageTitle && (
                    <PageHero
                        pageId={pageId}
                        pageTitle={pageTitle}
                        activePage={activePage}
                    />
                )}
                {children}

                <Footer />
            </div>
        </>
    );
}
